import React, { useState, useEffect } from 'react';

import RoundedCheckIconGrey from '../../../../../../icons/RoundedCheckIconGrey.svg';
import RoundedCheckIconGreen from '../../../../../../icons/RoundedCheckIconGreen.svg';


import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { getAlmaXCriteria } from '../../../../../../services/apiService';

import { toast } from 'react-toastify';

import ProgressBar from '../../../../../all-users/_components/progress-bar/component';

function AlmaX({ goalType, userId }) {
  const [rowData, setRowData] = useState(null);
  const [expandArray, setExpandArray] = useState([]);
  const [percentArray, setPercentArray] = useState([]);

  const fetchData = async () => {
    setExpandArray([]);
    try {
      if (goalType && userId) {
        const response = await getAlmaXCriteria(goalType, userId);
        setRowData(response);

        const mExpandArray = [];
        const mPercentArray = [];

        Object.keys(response?.moduleCriteriasMap).forEach((moduleItem) => {
          mExpandArray.push(false);

          let completedCount = 0;
          response?.moduleCriteriasMap[moduleItem].forEach((childItem) => {
            if (childItem.status === 'completed') completedCount++;
          });
          mPercentArray.push(
            completedCount / response?.moduleCriteriasMap[moduleItem].length
          );
        });
        setExpandArray(mExpandArray);
        setPercentArray(mPercentArray);
      }
    } catch (err) {
      console.error(err);
      toast.error('Failed to fetch data');
    }
  };

  useEffect(() => {
    fetchData();
  }, [goalType, userId]);

  return (
    <div>
      <div className='ag-theme-alpine bg-white py-8 h-full  w-full'>
        <div className='px-12 text-xl text-gray-500'>
          ProX (
          {Math.round(
            ((rowData?.solvedCriterias || 0) * 100) /
              (rowData?.totalCriterias > 0 ? rowData?.totalCriterias : 1)
          )}
          % )
        </div>
        <div>
          {rowData &&
            Object.keys(rowData?.moduleCriteriasMap).map((item, index) => {
              return (
                <div
                  key={index}
                  className='px-12 py-4 cursor-pointer'
                  onClick={() => {
                    const mExpandArray = expandArray.slice();
                    mExpandArray[index] = !mExpandArray[index];
                    setExpandArray(mExpandArray);
                  }}
                >
                  <div className='flex my-1'>
                    <div className='font-bold text-lg flex-1'>{item}</div>
                    {expandArray[index] ? <ExpandLess /> : <ExpandMore />}
                  </div>
                  <div className='w-full'>
                    <ProgressBar progress={percentArray[index]} bold={true} />
                  </div>
                  <div>
                    {expandArray[index] &&
                      rowData?.moduleCriteriasMap[item].map(
                        (moduleItem, index) => {
                          return (
                            <div
                              key={index}
                              className='flex gap-2 items-center my-2'
                            >
                              <div>
                                <img
                                  src={
                                    moduleItem?.status === 'completed'
                                      ? RoundedCheckIconGreen
                                      : RoundedCheckIconGrey
                                  }
                                />
                              </div>
                              <div>
                                {moduleItem?.assessmentName &&
                                  'Achieve > 75% in Competency Challenge - ' +
                                    moduleItem?.assessmentName}
                                {moduleItem?.projectCategoryName &&
                                  'Achieve > 70% in any of the Capstone Projects - ' +
                                    moduleItem?.projectCategoryName}
                              </div>
                            </div>
                          );
                        }
                      )}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
}

export default AlmaX;
